import {useTranslation} from 'react-i18next';
import StatusLabel from '../StatusLabel/StatusLabel';
import {TEticketTicket} from '../../../redux/eTicket/eTicket.type';
import {getHourMinutes, getDateFormat} from '../../../library/dates';
import ticketOpenImg from '../../../assets/images/eTicket/ticketOpen.webp';
import ticketScannedImg from '../../../assets/images/eTicket/ticketScanned.webp';
import ticketCanceledImg from '../../../assets/images/eTicket/ticketCanceled.webp';

interface TicketScanStatusProps {
    ticket: TEticketTicket;
}

function TicketScanStatus({ticket}: TicketScanStatusProps) {
    const {t} = useTranslation('eTicket');

    const scannedAt = ticket.scanTs && `${getHourMinutes(ticket.scanTs)} • ${getDateFormat(ticket.scanTs, 'D.M')}`;
    const labelByStatus = {
        canceled: {color: 'canceled', image: ticketCanceledImg, imageHeight: '67.353px', imageRotate: '13.998deg', text: t('statusCanceled')},
        scanned: {color: 'scanned', image: ticketScannedImg, imageShiftY: '9px', text: scannedAt ? `${t('statusScanned')} - ${scannedAt}` : t('statusScanned')},
        open: {color: 'brand', image: ticketOpenImg, imagePosition: 'end', imageShiftY: '9px', text: t('statusOpen')}
    } as const;

    const status = ticket.canceled ? 'canceled' : ticket.scanned ? 'scanned' : 'open';

    return <StatusLabel {...labelByStatus[status]} data-cy="ticket-scan-status" />;
}

export default TicketScanStatus;
